<script lang="ts">
    import { onMount } from 'svelte';
    import * as Popover from '$lib/components/ui/popover';
    import { getPredictiveState, type PredictiveState } from './predictive';
    import PredictiveModeSummary from './PredictiveModeSummary.svelte';

    // Says on the Program tab that Predictive Mode is on for the plan (running, or waiting for the plan's first activity), with a
    // question mark that explains it. Not shown when the mode is off or has ended, or on another athlete's page.
    let predictive: PredictiveState | null = null;
    onMount(async () => { predictive = await getPredictiveState(); });
    $: on = !!predictive?.applies && !predictive.ended && (predictive.enabled || predictive.choice === 'on');
</script>

{#if on}
    <div class="flex items-center justify-center gap-1" id="predictive-mode-badge">
        <span class="inline-flex items-center gap-2 rounded-full bg-xerteal-700 text-white font-semibold px-4 py-1.5">
            <i class="fa-solid fa-wand-magic-sparkles" aria-hidden="true"/>
            Predictive Mode is on
        </span>
        <Popover.Root portal="#shadcn-ui-dialog-target">
            <Popover.Trigger class="inline-flex items-center justify-center p-0 border-0 bg-transparent shadow-none rounded-full text-xerteal-700 hover:text-xerteal-600 outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:ring-0 focus-visible:outline-none" aria-label="What is Predictive Mode?">
                <i class="fa-regular fa-circle-question text-lg" aria-hidden="true"/>
            </Popover.Trigger>
            <Popover.Content side="bottom" align="center" collisionPadding={12} class="w-[min(26rem,calc(100vw-1.5rem))] min-w-0 text-gray-600 text-sm space-y-2 max-h-[70vh] overflow-y-auto">
                <PredictiveModeSummary {predictive} />
            </Popover.Content>
        </Popover.Root>
    </div>
{/if}
